import styled from 'styled-components'

export const AlarmRiskBollNotification = styled.div<{ color: string }>`
    min-width: 14px;
    min-height: 14px;
    background: ${({ color }) => color};
    border-radius: 50%;
`

export const EmailNotificationContainer = styled.div`
    .title-notification-email {
        display: flex;
        gap: 8px;
    }

    .label-title-email {
        font-size: 22px;
        font-weight: 600;
    }

    .label-name-group {
        font-weight: 400;
        font-size: 14px;
    }

    .label-time-notification {
        display: flex;
        align-items: center;
        gap: 9px;
        font-size: 12px;
        font-weight: 600;
    }

    .description-notification {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 18px 40px;
        margin: 24px 0;
    }
    .list-bowties-context {
        list-style-type: disc;
        display: flex;
        flex-direction: column;

        li {
            margin-left: 18px;
        }
    }
`

export const RiskNameNotification = styled.div<{ color: string }>`
    display: flex;
    justify-content: center;
    font-size: 13.8px;
    font-weight: 600;
    color: ${({ color }) => color};
    border: 1.15px solid ${({ color }) => color};
    gap: 9.2px;
    width: 53.4px;
    height: 23.6px;
    padding: 2px 9px;
    border-radius: 3.45px;
`
